import { DataItem } from '../DataItem';
import {
  clickableHoverClass,
  effectivePanelBackgroundCssClass,
  effectiveSizeCssClass,
} from './dataPanelItemBase';
import type { DataPanelItemBaseProps } from './dataPanelItemBase';

export type DataPanelItemProps = DataPanelItemBaseProps;

export function DataPanelItem(props: DataPanelItemProps) {
  const {
    title,
    value,
    allowCopyToClipboard,
    valueToCopy,
    customPanelTemplate,
    children,
    actionItems,
    showEmptyPlaceholder,
    showEmptyPlaceholderWhen,
    linkUrl,
    editable,
    onEditClick,
    clickable,
    onPanelClick,
    hoverTooltip,
  } = props;

  if (customPanelTemplate != null) {
    return (
      <div
        className={`data-panel-item p-2 ${effectiveSizeCssClass(props)} ${clickableHoverClass(props)}`}
        title={hoverTooltip}
      >
        {customPanelTemplate}
      </div>
    );
  }

  const panelItemClicked = async () => {
    if (clickable && onPanelClick) {
      await onPanelClick();
    }
  };

  return (
    <div
      className={`data-panel-item py-1 ${effectiveSizeCssClass(props)} ${clickableHoverClass(props)}`}
      onClick={() => void panelItemClicked()}
      title={hoverTooltip}
    >
      <div className={`panel-data-item__color px-1 rounded-2 ${effectivePanelBackgroundCssClass(props)}`}>
        <DataItem
          title={title}
          value={value}
          allowCopyToClipboard={allowCopyToClipboard}
          valueToCopy={valueToCopy}
          showEmptyPlaceholder={showEmptyPlaceholder}
          showEmptyPlaceholderWhen={showEmptyPlaceholderWhen}
          showEditButton={editable}
          onEditClick={onEditClick}
          linkUrl={linkUrl}
          actionItems={actionItems}
        >
          {children}
        </DataItem>
      </div>
    </div>
  );
}
